import { Directive, forwardRef } from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn,
} from '@angular/forms';
 
const EMAIL_REGEX =
  /^[a-zA-Z0-9_%+-]+(\.[a-zA-Z0-9_%+-]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/;
  
 
export function validateEmail(value: string | null): boolean {
  if (!value) return false;
  return EMAIL_REGEX.test(value);
}
 
/** Reusable validator for Reactive Forms: new FormControl('', [emailValidator()]) */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string | null;
    // Empty values are not invalidated here: Validators.required handles that
    if (!value) return null;
    return validateEmail(value) ? null : { invalidEmail: { value } };
  };
}
 
/** Usage (Template-driven): <input type="email" ngModel name="email" appEmailValidator /> */
@Directive({
  selector: '[appEmailValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EmailValidatorDirective),
      multi: true,
    },
  ],
})
export class EmailValidatorDirective implements Validator {
private readonly validator = emailValidator();

  validate(control: AbstractControl): ValidationErrors | null {
    return this.validator(control);
  }
}